import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../../components/ActionButton";
import FormFieldsTable from "../../../components/forms/FormFieldsTable";
import TextInputField from "../../../components/forms/TextInputField";
import DropDownInputField from "../../../components/forms/DropDownInputField";
import FormError from "../../../components/forms/FormError";

function numerical(value) {
  let parsed = parseInt(value, 10);
  if (isNaN(parsed)) return value;
  return parsed;
}

class AddProductToBundleForm extends Component {

  render() {
    let {errors, handleSubmit, submit, products, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label="Product"
              name="product_sku"
              component={DropDownInputField}
              data={products}
              valueKey="sku"  
              titleKey="title" 
              showBlank={true}
              serverError={this.props.errors.product_sku}
              />
            <Field 
              label="Quantity"
              name="quantity"
              component={TextInputField}
              normalize={numerical}
              serverError={this.props.errors.quantity}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "AddProductToBundleForm"
})(AddProductToBundleForm);

export default ReduxForm;